export const ICON = {
  NEWSROOM1: 'COMMON_ICON_NEWSROOM1',
  PERFORMANCES: 'COMMON_ICON_PERFORMANCES',
  FICHE_INNO_ILLU1: 'COMMON_ICON_FICHE_INNO_ILLU1',
  FICHE_INNO_ILLU2: 'COMMON_ICON_FICHE_INNO_ILLU2',
};
